import type React from 'react';

/**
 * Results page frame: the report centered in the space left of a 356px promo rail that, on wide screens, runs
 * flush against the right edge of the window (Figma "Ready for development"). On phones the rail
 * stacks under the report.
 */
export function ResultsLayout({ children, rail }: { children: React.ReactNode; rail: React.ReactNode }) {
  return (
    <div className="lg:grid lg:grid-cols-[minmax(0,1fr)_356px] lg:items-start">
      <div className="min-w-0 px-4 py-6 sm:px-6 sm:py-10 lg:pl-9 lg:pr-10">
        <div className="mx-auto max-w-5xl">{children}</div>
      </div>
      <aside className="flex flex-col gap-[26px] px-4 pb-10 sm:px-6 lg:px-0">{rail}</aside>
    </div>
  );
}
